import { useEffect, useState } from 'react';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';
import { getHashFromURL, once } from '@noths/polaris-client-utils';

import { DELIVERY_DRAWER_URL_FRAGMENT_ID } from 'src/fragmentIDs';

export interface UseDeliveryDrawer {
  isOpen: boolean;
  onClose: () => void;
}

const sendViewContentEventOnce = once(() => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event_v2',
      event_name: 'view_content',
      event_details: undefined,
      content_type: 'delivery information',
      item_id: undefined,
    }),
  );
});

export const useDeliveryDrawer = (): UseDeliveryDrawer => {
  const [isOpen, setIsOpen] = useState(false);

  const handleHashChange = ({ newURL }: Pick<HashChangeEvent, 'newURL'>) => {
    const hashIsDeliveryDrawer = getHashFromURL(newURL) === DELIVERY_DRAWER_URL_FRAGMENT_ID;

    setIsOpen(hashIsDeliveryDrawer);

    if (hashIsDeliveryDrawer) {
      sendViewContentEventOnce();
    }
  };

  const onClose = () => {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    handleHashChange({ newURL: window.location.href });
  };

  useEffect(() => {
    window.addEventListener('hashchange', handleHashChange);

    handleHashChange({ newURL: window.location.href });

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isOpen, onClose };
};
